import { Box, IconButton, Stack, Typography } from "@mui/material";
import {
  gridFilteredDescendantCountLookupSelector,
  GridRenderCellParams,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";
import { MdsExpandLess, MdsExpandMore } from "@sinch/icons";
import * as React from "react";
import { FC, MouseEventHandler, useCallback } from "react";
import { MdsIcon } from "@sinch/components";
import { Row } from "@sinch/components/application/RatesCompositionTable/RatesCompositionTable";

const ICON_PLACEHOLDER_WIDTH = "34px";
export const CustomGridTreeDataGroupingCell: FC<GridRenderCellParams<Row>> = (props) => {
  const { id, field, rowNode, row } = props;
  const apiRef = useGridApiContext();
  const filteredDescendantCountLookup = useGridSelector(apiRef, gridFilteredDescendantCountLookupSelector);
  const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

  const isExpandable = filteredDescendantCount > 0 && rowNode.type === "group";

  const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (event) => {
      if (rowNode.type !== "group") return;

      apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
      apiRef.current.setCellFocus(id, field);
      event.stopPropagation();
    },
    [apiRef, id, field, rowNode]
  );

  return (
    <Box /*sx={{ ml: rowNode.depth }}*/>
      <Stack alignItems="center" direction="row">
        {isExpandable ? (
          <IconButton onClick={handleClick} size="small" tabIndex={-1}>
            <MdsIcon icon={rowNode.childrenExpanded ? MdsExpandLess : MdsExpandMore} />
          </IconButton>
        ) : (
          <Box sx={{ width: ICON_PLACEHOLDER_WIDTH }} />
        )}
        <Typography>{row.label}</Typography>
      </Stack>
    </Box>
  );
};
